import type { CardItemBreedProps } from '@presentation/components';
import { CardItem, IconScalePaws } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { ContentTitle } from '../CardItem/styled';
import { Skeleton } from './components/Skeleton';
import * as Styled from './styled';

export * from './types';

export const CardItemBreed: FC<CardItemBreedProps> = (props) => {
  const { translate } = useTranslation();
  const {
    image,
    onClick,
    name,
    attributes,
    loading = false,
    footerText = translate('common.buttons.details'),
    dontTruncate,
    ...rest
  } = props;

  if (loading) <Skeleton />;

  return (
    <CardItem
      onClick={onClick}
      image={image}
      footer={<Styled.FooterText>{footerText}</Styled.FooterText>}
      {...rest}
    >
      <ContentTitle dontTruncate={dontTruncate}>{name}</ContentTitle>
      <Styled.Container>
        {Object.keys(attributes ?? {})
          .filter((key) => attributes?.[key as keyof typeof attributes] != null)
          .map((key, index) => (
            <Styled.Wrapper key={index}>
              <Styled.Label>{translate(`glossary.breedInfo.${key}.title`)}</Styled.Label>
              <Styled.Value>
                <IconScalePaws
                  amount={attributes?.[key as keyof typeof attributes] ?? 0}
                  maxAmount={3}
                />
              </Styled.Value>
            </Styled.Wrapper>
          ))}
      </Styled.Container>
    </CardItem>
  );
};
